const fromStoreOpeningTimesByCodeQueryToOpeningTimes = (data)=>{
    if (!data) {
        return null;
    }
    try {
        return Object.entries(data).reduce((acc, [key, value])=>{
            if (key === '__typename') {
                return acc;
            } else if (key === 'specialOpenClosingHours') {
                acc[key] = value && Object.values(value).map((entry1)=>({
                        dateOpenClosed: entry1.dateOpenClosed,
                        openClosed: entry1.openClosed,
                        openClosedTime: entry1.openClosedTime ? entry1.openClosedTime.map((entry)=>({
                                open: entry.open,
                                close: entry.close
                            })
                        ) : null
                    })
                );
            } else {
                acc[key] = value ? Object.values(value).map((entry)=>({
                        open: entry.open,
                        close: entry.close
                    })
                ) : null;
            }
            return acc;
        }, {
            monOpenClose: null,
            tueOpenClose: null,
            wedOpenClose: null,
            thuOpenClose: null,
            friOpenClose: null,
            satOpenClose: null,
            sunOpenClose: null,
            specialOpenClosingHours: null
        });
    } catch (e) {
        console.error('Store offer data adapter failed to parse input data correctly.', e, data);
        return null;
    }
};

export { fromStoreOpeningTimesByCodeQueryToOpeningTimes };
//# sourceMappingURL=fromStoreOpeningTimesQueryToOpeningTimes.js.map
